











 













const node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "GitLabProviders_orgIntegrationProviders",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "IntegrationProviderOAuth2",
      "kind": "LinkedField",
      "name": "gitlab",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "GitLabProviderRow_integrationProvider"
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "serverBaseUrl",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "clientId",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "OrgIntegrationProviders",
  "abstractKey": null
};

(node ).hash = "ae49842459b73279860e619d42a5e88c";

export default node;
